import { render } from "./AdminAnnouncements.vue?vue&type=template&id=a914fd28"
import script from "./AdminAnnouncements.vue?vue&type=script&lang=js"
export * from "./AdminAnnouncements.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__